import * as React from 'react';
import {Path, SvgProps} from 'react-native-svg';
import Icon from './Icon';

const StoreMapIcon = (props: SvgProps) => (
  <Icon {...props}>
    <Path d="M20 6H4V4h16v2Zm-5.7 6c-.8.96-1.3 2.18-1.3 3.5 0 1.14.43 2.36 1 3.5v1H4v-6H3v-2l1-5h16l.7 3.5c-.66-.32-1.38-.5-2.14-.5l-.2-1H5.64l-.6 3h9.26ZM12 14H6v4h6v-4Zm10 1.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5Zm-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z" />
  </Icon>
);
export default StoreMapIcon;
